import type { CityConfig } from "../city-template/types";

export const charlottesvilleVaConfig: CityConfig = {
  city: "Charlottesville",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "charlottesville-va",
  route: "/cities/charlottesville-va",
  title: "Emergency Passport Charlottesville, VA | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Charlottesville, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving UVA students, faculty, and all of Central Virginia. Get your passport fast for study abroad and international travel!",
  h1: "Emergency & Expedited Passport Services in Charlottesville, VA",
  heroSubtitle: "Studying abroad at UVA? Passport expired before your research trip? Need an emergency passport fast? We help Charlottesville and Central Virginia travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Historic%20Charlottesville%20Virginia%20downtown%20with%20the%20University%20of%20Virginia%20Rotunda%20dome%20in%20the%20background%2C%20charming%20brick%20buildings%20along%20the%20Downtown%20Mall%20pedestrian%20street%2C%20lush%20green%20trees%20and%20mountains%20in%20the%20distance%2C%20warm%20afternoon%20golden%20light%2C%20professional%20photography%20with%20rich%20autumn%20tones%20and%20historic%20collegiate%20atmosphere%2C%20no%20people%20visible%2C%20classic%20American%20college%20town%20beauty%20with%20Jeffersonian%20architecture&width=1800&height=700&seq=charlottesville-va-hero-001&orientation=landscape",
  heroImageAlt: "Historic Charlottesville Virginia downtown with the University of Virginia Rotunda and charming Downtown Mall pedestrian street",
  geoPosition: "38.0293;-78.4767",
  geoPlacename: "Charlottesville, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 100 miles northeast of Charlottesville via I-64 and I-95",
  },
  nearbyCitiesZips: [
    { name: "Charlottesville", zips: "22901, 22902, 22903, 22904, 22905, 22906, 22907, 22908, 22909, 22910, 22911" },
    { name: "Albemarle County", zips: "22901, 22902, 22903, 22911, 22936, 22947, 22972, 22974" },
    { name: "Waynesboro", zips: "22980" },
    { name: "Staunton", zips: "24401, 24402" },
    { name: "Harrisonburg", zips: "22801, 22802, 22803, 22807" },
    { name: "Lynchburg", zips: "24501, 24502, 24503, 24504, 24505, 24506, 24515" },
    { name: "Fredericksburg", zips: "22401, 22402, 22403, 22404, 22405, 22406, 22407, 22408, 22412" },
    { name: "Richmond", zips: "23218, 23219, 23220, 23221, 23222, 23223, 23224, 23225, 23226, 23227, 23228, 23229, 23230, 23231, 23233, 23234, 23235, 23236, 23237, 23238, 23242" },
    { name: "Roanoke", zips: "24001, 24002, 24003, 24004, 24005, 24006, 24007, 24008, 24009, 24010, 24011, 24012, 24013, 24014, 24015, 24016, 24017, 24018, 24019, 24020, 24022, 24023, 24024, 24025, 24026, 24027, 24028, 24029, 24030, 24031, 24032, 24033, 24034, 24035, 24036, 24037, 24038, 24040, 24042, 24043, 24044, 24045, 24048, 24050, 24054, 24055, 24059, 24060, 24061, 24062, 24063, 24064, 24065, 24066, 24067, 24068, 24070, 24072, 24073, 24077, 24078, 24079, 24083, 24084, 24085, 24086, 24087, 24088, 24089, 24090, 24091, 24092, 24095" },
    { name: "Blacksburg", zips: "24060, 24061, 24062, 24063" },
    { name: "Winchester", zips: "22601, 22602, 22603, 22604" },
    { name: "Winchester", zips: "22601, 22602, 22603, 22604" },
    { name: "Fairfax", zips: "22030, 22031, 22032, 22033" },
    { name: "Arlington", zips: "22201, 22202, 22203, 22204, 22205, 22206, 22207, 22209, 22213, 22214, 22217" },
    { name: "Alexandria", zips: "22301, 22302, 22303, 22304, 22305, 22306, 22307, 22308, 22309, 22310, 22311, 22312, 22314, 22315" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent study abroad and research departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Central Virginia Hub", desc: "Serving Charlottesville, UVA, and all of Central Virginia" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Richmond VA passport services", route: "/cities/richmond-va" },
    { name: "Fairfax VA passport services", route: "/cities/fairfax-va" },
    { name: "Arlington VA passport services", route: "/cities/arlington-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Charlottesville remotely via secure courier. We do not have a walk-in office in Charlottesville — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Charlottesville and Central Virginia travelers.",
  fpcOfficeDistance: "Serving all of Charlottesville and the surrounding Central Virginia area including Albemarle County, Waynesboro, Staunton, Harrisonburg, Lynchburg, and the entire Shenandoah Valley region",
  serviceAreaIntro: "From the historic Downtown Mall to the grounds of the University of Virginia, from the quiet neighborhoods of Fry's Spring and Belmont to the rolling hills of Albemarle County — Fast Passport Center serves every corner of Charlottesville and Central Virginia. We regularly help UVA students, faculty, and families from Waynesboro, Staunton, Harrisonburg, and Lynchburg get their passports fast.",
  nearbyCitiesIntro: "We serve all Charlottesville neighborhoods and the surrounding Central Virginia region including Albemarle County, Waynesboro, Staunton, Harrisonburg, Lynchburg, Fredericksburg, Richmond, Roanoke, Blacksburg, and Winchester. If you are anywhere in the Charlottesville area or the broader Central Virginia and Shenandoah Valley region, we have you covered.",
  howItWorksIntro: "Most Charlottesville travelers complete everything online and ship documents overnight. No need to drive to Washington, DC or wait in line at the regional agency.",
  mistakesIntro: "Charlottesville travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Charlottesville and Central Virginia travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Charlottesville? Here are the most common ones we hear from UVA students, faculty, and Central Virginia travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Charlottesville international flights and study abroad programs.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Emily R.",
      location: "Charlottesville, VA",
      rating: 5,
      text: "I needed an emergency passport for my UVA study abroad program in Spain. I realized my passport was expired just two weeks before departure. Fast Passport Center had my renewal processed in 4 days. I shipped from the UPS near the Downtown Mall and never missed my program. Absolutely essential for students!",
      service: "Passport Renewal",
    },
    {
      name: "Dr. James K.",
      location: "Charlottesville, VA",
      rating: 5,
      text: "As a UVA professor heading to a research conference in Berlin, I had a passport crisis with 5 days to go. Fast Passport Center delivered in 3 days. Their understanding of academic travel schedules was a huge relief. I highly recommend them to any faculty member at the university.",
      service: "Emergency Passport",
    },
    {
      name: "Sarah M.",
      location: "Albemarle County, VA",
      rating: 5,
      text: "First passports for my three kids before our family trip to Italy. Fast Passport Center handled the parental consent requirements and had all three passports in 5 days. The Charlottesville-area service was incredibly convenient for our busy schedule with school activities.",
      service: "Child Passport",
    },
    {
      name: "Michael T.",
      location: "Waynesboro, VA",
      rating: 5,
      text: "Lost my passport 48 hours before a business trip to London. I was absolutely panicking. Fast Passport Center had a replacement in my hands in 36 hours. They saved an important client meeting that I had been preparing for months. Charlottesville area service is top notch.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "charlottesville-va-1",
      name: "Charlottesville Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "810 W Main St",
      city: "Charlottesville",
      state: "VA",
      zip: "22903",
      phone: "(434) 295-6221",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Charlottesville, near UVA",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Charlottesville facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "charlottesville-va-2",
      name: "University of Virginia Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "530 McCormick Rd",
      city: "Charlottesville",
      state: "VA",
      zip: "22904",
      phone: "(434) 924-3366",
      hours: "Mon–Fri: 10:00 AM – 3:00 PM",
      distance: "UVA Grounds, near the Rotunda",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for UVA students and faculty. Full passport services with appointment. Limited hours — plan ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "charlottesville-va-3",
      name: "Albemarle County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "401 McIntire Rd",
      city: "Charlottesville",
      state: "VA",
      zip: "22902",
      phone: "(434) 972-4083",
      hours: "Mon–Fri: 8:30 AM – 5:00 PM",
      distance: "Charlottesville Government Center",
      website: "https://www.albemarle.org/",
      websiteLabel: "Albemarle County Clerk",
      notes: "Major county facility for Albemarle County. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
    {
      id: "charlottesville-va-4",
      name: "Waynesboro Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1000 W Main St",
      city: "Waynesboro",
      state: "VA",
      zip: "22980",
      phone: "(540) 949-4435",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Waynesboro, west of Charlottesville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Waynesboro and western Albemarle County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "charlottesville-va-5",
      name: "Staunton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1430 N Augusta St",
      city: "Staunton",
      state: "VA",
      zip: "24401",
      phone: "(540) 885-8374",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Staunton, west of Charlottesville in the Shenandoah Valley",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Staunton and the Shenandoah Valley. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "charlottesville-va-6",
      name: "Harrisonburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1951 Evelyn Byrd Ave",
      city: "Harrisonburg",
      state: "VA",
      zip: "22801",
      phone: "(540) 434-0301",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Harrisonburg, north of Charlottesville in the Shenandoah Valley",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Harrisonburg and James Madison University area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive into downtown DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Charlottesville photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Central Virginia acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Charlottesville applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Charlottesville families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Charlottesville travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Charlottesville or nearby." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Charlottesville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Charlottesville before study abroad?", a: "Yes. Fast Passport Center provides emergency passport services in Charlottesville for travelers with urgent international departures including study abroad programs. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the long drive to Washington, DC." },
    { q: "How fast can I renew my passport in Charlottesville?", a: "Fast Passport Center offers fast passport renewal in Charlottesville in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Charlottesville?", a: "The nearest regional passport agency to Charlottesville is the Washington Passport Agency, located approximately 100 miles away in downtown Washington, DC. For urgent processing without navigating DC traffic and parking, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Charlottesville without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Charlottesville?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Charlottesville residents." },
    { q: "Can I expedite a child passport in Charlottesville?", a: "Yes. Fast Passport Center expedites child passports in Charlottesville for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Charlottesville families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Charlottesville with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Charlottesville?", a: "With Fast Passport Center's emergency courier service, Charlottesville travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Charlottesville?", a: "Popular options include the Charlottesville Main Post Office (22903), University of Virginia Post Office (22904), Albemarle County Clerk (22902), Waynesboro Post Office (22980), Staunton Post Office (24401), and Harrisonburg Post Office (22801). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Charlottesville?", a: "Same-day passports are only available at the Washington Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option — without the DC traffic and parking hassle." },
    { q: "What if I live in a smaller Central Virginia town?", a: "We serve the entire Central Virginia and Shenandoah Valley region including Albemarle County, Waynesboro, Staunton, Harrisonburg, Lynchburg, Fredericksburg, Richmond, Roanoke, Blacksburg, and Winchester. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Charlottesville?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
    { q: "Do you help with passport photos in Charlottesville?", a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and FedEx Office locations in Charlottesville, Waynesboro, and Harrisonburg offer passport photo services. We review your photos before submission to ensure they meet State Department standards." },
    { q: "What documents do I need for a first-time passport in Charlottesville?", a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk." },
    { q: "Can you help with a child's passport in Charlottesville?", a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Charlottesville families through the entire process and help schedule acceptance clerk appointments." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Charlottesville", address: "1035 Emmet St N, Charlottesville, VA 22903", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Charlottesville", address: "2101 Ivy Rd, Charlottesville, VA 22903", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Charlottesville", address: "1535 Avon St Extended, Charlottesville, VA 22902", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "CVS Pharmacy — Waynesboro", address: "801 Town Center Dr, Waynesboro, VA 22980", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Staunton", address: "901 Richmond Ave, Staunton, VA 24401", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Harrisonburg", address: "1675 E Market St, Harrisonburg, VA 22801", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Harrisonburg", address: "1625 Reservoir St, Harrisonburg, VA 22801", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Harrisonburg", address: "1495 E Market St, Harrisonburg, VA 22801", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Charlottesville",
      address: "1046 Reservoir St, Charlottesville, VA 22901",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Waynesboro",
      address: "1100 W Broad St, Waynesboro, VA 22980",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Staunton",
      address: "1880 Churchville Ave, Staunton, VA 24401",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Staunton and western Shenandoah Valley. REAL ID available.",
      featured: false,
    },
    {
      name: "Virginia DMV — Harrisonburg",
      address: "3281 Peoples Dr, Harrisonburg, VA 22801",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Harrisonburg and JMU area. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "CHO",
      name: "Charlottesville-Albemarle Airport",
      distance: "8 miles north of Charlottesville",
      address: "1000 Bowen Loop, Charlottesville, VA 22911",
      note: "The primary airport for Charlottesville and Central Virginia. Direct flights to major hubs including Atlanta, Charlotte, Chicago, and New York — perfect for UVA students and faculty connecting to international destinations. Accessible via Route 29.",
      flightUrl: "https://www.gocho.com/",
      flightLabel: "CHO Airport",
      featured: true,
    },
    {
      code: "DCA",
      name: "Ronald Reagan Washington National Airport",
      distance: "110 miles northeast of Charlottesville",
      address: "2401 Smith Ave, Arlington, VA 22202",
      note: "Major international hub for long-haul flights. Accessible via I-64 and I-95.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: false,
    },
    {
      code: "IAD",
      name: "Dulles International Airport",
      distance: "120 miles northeast of Charlottesville",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Major international hub for long-haul flights to Europe, Asia, and beyond. Accessible via I-64 and I-66.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Airport",
      featured: false,
    },
    {
      code: "RIC",
      name: "Richmond International Airport",
      distance: "75 miles southeast of Charlottesville",
      address: "1 Richard E Byrd Terminal Dr, Richmond, VA 23250",
      note: "Alternative regional hub for domestic flights. Accessible via I-64.",
      flightUrl: "https://www.flyrichmond.com/",
      flightLabel: "RIC Airport",
      featured: false,
    },
  ],
};